import {Component} from "@angular/core";
import {AuthService} from "@fedeltapointofsale/data-client";
import {AnalyticsService} from "../../analytics/analytics.service";

@Component({
    selector: "wbo-help-chrome-control",
    templateUrl: "./help-chrome-control.component.html",
    styleUrls: ["./help-chrome-control.component.scss"]
})
export class HelpChromeControlComponent {
    constructor(public authService: AuthService,
                private analyticsService: AnalyticsService) {
    }

    open(): void {
        window.open("http://help.chewzie.me");
    }
}
